import { Card, CardContent, Typography } from '@mui/material'
import ReactECharts from 'echarts-for-react'

interface GeoChartProps {
    data: Array<{ country: string; visitors: number }>
    title?: string
}

export function GeoChart({ data, title = 'Top Countries' }: GeoChartProps) {
    const top = data.slice(0, 10)

    const option = {
        tooltip: { trigger: 'axis' as const, axisPointer: { type: 'shadow' as const } },
        grid: { left: '3%', right: '12%', bottom: '3%', containLabel: true },
        xAxis: { type: 'value' as const },
        yAxis: {
            type: 'category' as const,
            data: top.map(d => d.country || 'Unknown'),
            inverse: true,
        },
        series: [
            {
                type: 'bar' as const,
                data: top.map(d => d.visitors),
                itemStyle: { color: '#6366f1', borderRadius: [0, 4, 4, 0] },
                label: { show: true, position: 'right' as const, formatter: '{c}' },
            },
        ],
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {title}
                </Typography>
                {top.length > 0 ? (
                    <ReactECharts option={option} style={{ height: 300 }} />
                ) : (
                    <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
                        No geo data yet
                    </Typography>
                )}
            </CardContent>
        </Card>
    )
}
